import React, { useEffect, useState } from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Alert from "../../components/alert/alert";
import DashboardFooter from "../../components/DashBoardFooter/dashboardFooter";
import Preloader from "../../components/preloader/Preloader";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { auth, firestore } from "../../db/config";
import moment from "moment";
import { useSelector } from "react-redux";
export default function PaymentRequest() {
  const [userBalance, setuserBalance] = useState("");
  const [transferState, settransferState] = useState({
    choosenAccountBalance: "",
    accountId: "",
    amount: "",
    paymentMethod: "",
    transactionPin: "",
  });
  const userReducer = useSelector((state) => state.userReducer);
  const getCurrentUser = userReducer ? userReducer.currentUser : "";

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      const getRef = firestore
        .collection("userPaymentDetails")
        .doc(user.uid)
        .get();
      getRef.then((bal) => {
        setuserBalance(bal.data());
      });
    });
  }, []);

  //   console.log(userBalance.payPalBalance);
  const handleChange = (value) => {
    if (value === "payPalBalance") {
      settransferState({
        ...transferState,
        choosenAccountBalance: userBalance.payPalBalance,
        paymentMethod: "payPal",
      });
    } else if (value === "bitcoinBalance") {
      settransferState({
        ...transferState,
        choosenAccountBalance: userBalance.bitcoinBalance,
        paymentMethod: "bitcoin",
      });
    } else if (value === "cashAppBalance") {
      settransferState({
        ...transferState,
        choosenAccountBalance: userBalance.cashAppBalance,
        paymentMethod: "cash app",
      });
    } else {
      settransferState({
        ...transferState,
        choosenAccountBalance: userBalance.cashierCheckDepositBalance,
        paymentMethod: "cashier's check deposit",
      });
    }
  };
  const handleBankDetails = (value, attr) => {
    settransferState({
      ...transferState,
      [attr]: value,
    });
  };
  const [alertMessage, setalertMessage] = useState({
    message: "",
    status: "",
    buttonStatus: false,
    loader: false,
  });
  const handleSubmit = () => {
    setalertMessage({
      ...alertMessage,
      loader: true,
    });
    if (transferState.choosenAccountBalance === "") {
      setalertMessage({
        ...alertMessage,
        status: "danger",
        message: "Please select a payment method",
        loader: false,
      });
    } else if (transferState.amount === "" || transferState.accountId === "") {
      setalertMessage({
        ...alertMessage,
        status: "danger",
        message: "Plaease fill out all empty fields",
        loader: false,
      });
    } else if (transferState.amount > transferState.choosenAccountBalance) {
      setalertMessage({
        ...alertMessage,
        status: "danger",
        message: "Error, Insufficient balance.",
        loader: false,
      });
    } else if (transferState.transactionPin !== getCurrentUser.transactionPin) {
      setalertMessage({
        ...alertMessage,
        status: "danger",
        message: "Incorrect pin.",
        loader: false,
      });
    } else {
      auth.onAuthStateChanged((user) => {
        firestore
          .collection("paymentRequest")
          .add({
            ...transferState,
            userId: user.uid,
            createdAt: moment().format("MMMM Do YYYY, h:mm:ss a"),
            description: "payment request from " + transferState.paymentMethod,
            status: "pending",
            transferType: "Make Pay Out",
          })
          .then(() => {
            alert(
              "Your request for $" +
                transferState.amount +
                " is successful, order will proceed once confirmed."
            );
            window.location.href("/payment_request");
          })
          .catch((error) => {
            setalertMessage({
              ...alertMessage,
              status: "danger",
              message: error.message,
              loader: false,
            });
          });
      });
    }
  };
  return (
    <div>
      <AboutHeader />

      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>Make Payout </h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>Make Payout</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />

        <div class="payment_transfer_Wrapper float_left">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_center">
                <h3>Make Payout</h3>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-sm-12 col-12">
              <div class="change_password_wrapper float_left">
                <div class="change_pass_field float_left">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="payPalBalance"
                      onChange={(evt) => handleChange(evt.target.value)}
                    />
                    <label class="form-check-label" for="inlineRadio1">
                      paypal
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="bitcoinBalance"
                      onChange={(evt) => handleChange(evt.target.value)}
                    />
                    <label class="form-check-label" for="inlineRadio2">
                      bitcoin
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="cashAppBalance"
                      onChange={(evt) => handleChange(evt.target.value)}
                    />
                    <label class="form-check-label" for="inlineRadio2">
                      cash app
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="cashierCheckDepositBalance"
                      onChange={(evt) => handleChange(evt.target.value)}
                    />
                    <label class="form-check-label" for="inlineRadio2">
                      cashier's check deposit
                    </label>
                  </div>
                  {/* <div class="payment_gateway_wrapper payment_select_wrapper">
                    <label>Select Payment Mode :</label>
                    <select
                      value={transferState.paymentMethod}
                      onChange={(evt) => handleChange(evt.target.value)}
                    >
                      <option selected>choose gateway</option>
                      <option value="payPalBalance">paypal</option>
                      <option value="bitcoinBalance">bitcon</option>
                      <option value="cashAppBalance">cash app</option>
                      <option value="cashierCheckDepositBalance">
                        cashier's check deposit
                      </option>
                    </select>
                  </div> */}

                  {/* <select
                    class="form-select"
                    aria-label="Default select example"
                    onChange={(evt) => handleChange(evt.target.value)}
                  >
                    <option selected>Open this select menu</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select> */}
                  <div class="change_field" style={{ marginTop: "10px" }}>
                    <label>available balance :</label>
                    <input
                      type="text"
                      name="password"
                      placeholder="000 USD"
                      value={transferState.choosenAccountBalance + " USD"}
                      disabled
                    />
                  </div>

                  <div class="change_field">
                    <label>Account ID :</label>
                    <input
                      type="text"
                      name="password"
                      placeholder="Address to direct payment"
                      onChange={(evt) =>
                        handleBankDetails(evt.target.value, "accountId")
                      }
                    />
                  </div>
                  <div class="change_field">
                    <label>amount :</label>
                    <input
                      type="number"
                      name="password"
                      placeholder="000 USD"
                      onChange={(evt) =>
                        handleBankDetails(evt.target.value, "amount")
                      }
                    />
                  </div>
                  <div class="change_field">
                    <label>transaction pin :</label>
                    <input
                      type="password"
                      name="password"
                      placeholder="000 USD"
                      onChange={(evt) =>
                        handleBankDetails(evt.target.value, "transactionPin")
                      }
                    />
                  </div>
                  <div class="about_btn float_left">
                    {alertMessage.message ? (
                      <Alert details={{ ...alertMessage }} />
                    ) : (
                      ""
                    )}
                    <ul>
                      <li>
                        {alertMessage.loader ? (
                          <Preloader />
                        ) : (
                          <a
                            className="handle__updates__button"
                            onClick={handleSubmit}
                          >
                            transfer
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <DashboardFooter />
      </div>
    </div>
  );
}
